import http from '@/services/http'
import { taskUrl } from '../../url'
import type * as Types from './type'

interface IOrderSync {
  source: string
  storeIds: string[]
  startTime?: number
  endTime?: number
  orderMcIds?: string[]
}

/**
 * 同步订单
 * @param data
 * @returns
 */
export const postOrderSync = (data: IOrderSync): Promise<any> => http.admin.post(taskUrl.orderSync, data, { toast: true })

/**
 * 列表导出
 */
export const exportList = (data: Types.ExportListParam): Promise<any> => http.admin.post(taskUrl.taskExport, data, { toast: true })

/**批量导入 */
export const batchImport = (data): Promise<any> => http.admin.post(taskUrl.batchImport, data)

/** 查询任务详情 */
export const getTaskDetail = (params: Types.TasksGetReq) => http.admin.get<Types.TasksGetRes>('/api/tasks/get', { params })
